import './styles/styles.scss';

import 'picturefill/dist/picturefill';
import 'picturefill/dist/plugins/mutation/pf.mutation';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);
import Glide from '@glidejs/glide';
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

lazySizes.cfg.expand = 300;
lazySizes.cfg.expFactor = 1.25;
lazySizes.init();

const root = document.getElementsByTagName('html')[0];
const body = document.getElementsByTagName('body')[0];
var main = document.getElementsByTagName('main')[0];
const navbarMenu = document.querySelector('.navbar-menu');
const navbarBurger = document.querySelector('.navbar-burger');
const navbar = document.querySelector('nav.navbar');

var ww = window.innerWidth,
    wh = window.innerHeight;

var isScrolling = false;
var position = window.pageYOffset || document.documentElement.scrollTop;
var scrollPosition;
let tableContent = document.querySelector('#table-of-contents');
// let largeHeader = document.getElementById('header-large');
let articleContent = document.getElementById('article-content');
let tableContentClose = document.querySelector('#close-toc');
let tableContentLinks = Array.from(document.querySelectorAll('.table-of-contents .table-content-heading a'));
let internalLinks = Array.from(document.querySelectorAll('[data-type="internal"]'));
// console.log('internalLinks', internalLinks);
let scrollToLinks = [].concat(tableContentLinks, internalLinks);
let tableContentHeadings = document.querySelectorAll('.table-content-heading');
let tocCloseOffset = body.classList.contains('single-post') ? offset(articleContent).left : null; //- tableContentClose.offsetWidth 
let tocOffset = body.classList.contains('single-post') ? -tableContent.offsetWidth - offset(tableContent).left : null;
let lastId;
var navbaroffset;
let cur = [];
var pndmsnry;
console.log('position', position);

gsap.set(main, { paddingTop: ww > 1280 ? navbarMenu.offsetHeight : navbar.offsetHeight });
body.classList.contains('single-post') || body.classList.contains('category') ? document.querySelector('.navbar-end .item-editions').classList.add('current-menu-item') : null;
body.classList.contains('single-post') ? gsap.set(tableContent, { paddingTop: navbarMenu.offsetHeight }) : null;
body.classList.contains('single-post') ? gsap.set(tableContentClose, { x: tocCloseOffset }) : null;


function initMasonryGrid(container) {
    pndmsnry = new Masonry(container, {
        itemSelector: '.pnd-article',
        // columnWidth: itemSize,
        percentPosition: true,
        gutter: 0,
        transitionDuration: '0.8s',
        // initLayout: false
    });
    imagesLoaded(container, function() {
        pndmsnry.layout();
    });
}

if (body.classList.contains('home') || body.classList.contains('page-template-template-editions')) {
    const gridcontainer = body.classList.contains('home') ? document.querySelector('.home-articles-wrapper') : document.querySelector('.editions-wrapper');
    // if (body.classList.contains('home')) {
    //     window.almComplete = function(alm) {
    //         console.log('alm', alm);
    //         initMasonryGrid(gridcontainer);
    //     }
    // } else {
    if (ww > 768) {
        initMasonryGrid(gridcontainer);
    }
    // }
}


function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

var scrollDistance = function(callback, refresh) {
    if (!callback || typeof callback !== 'function') return;

    var isScrolling, start, end, distance;
    window.addEventListener('scroll', function(event) {
        if (!start) {
            start = window.pageYOffset;
        }
        window.clearTimeout(isScrolling);
        isScrolling = setTimeout(function() {
            end = window.pageYOffset;
            distance = end - start;
            callback(distance, start, end);
            start = null;
            end = null;
            distance = null;
        }, refresh || 66);
    }, false);
};

scrollDistance(function(distance) {
    // console.log('You travelled ' + parseInt(Math.abs(distance), 10) + 'px ' + (distance < 0 ? 'up' : 'down'));
    if (body.classList.contains('single-post')) {
        if (distance < 0) {
            navbar.classList.remove('is-scrolled');
            gsap.to(navbar, {
                y: '0%',
                duration: .3,
                ease: 'power3.easeOut',
                delay: .5
            });
        }
    }
});


window.addEventListener('scroll', event => {
    let fromTop = window.scrollY;
    // console.log('fromTop', fromTop);
    // console.log('scrollPosition', scrollPosition);
    // console.log('isScrolling', isScrolling);
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    if (ww > 768) {
        if (body.classList.contains('single-post')) {
            if (isScrolling === false) {
                if (scrollPosition > position && scrollPosition >= navbar.offsetHeight * 2) {
                    // scrollDirection DOWN
                    navbar.classList.add('is-scrolled');
                    gsap.to(navbar, {
                        y: '-100%',
                        duration: .3,
                        ease: 'power3.easeOut',
                        delay: .2
                    });
                } else {
                    // scrollDirection UP
                    // navbar.classList.remove('is-scrolled');
                    // gsap.to(navbar, {
                    //     y: '0%',
                    //     duration: .3,
                    //     ease: 'power3.easeOut',
                    //     delay: .5
                    // });
                }
            }

            if (typeof(tableContent) != 'undefined' && tableContent != null) {
                // if (scrollPosition < position && scrollPosition <= navbar.offsetHeight) {
                if (fromTop === 0 && tableContentClose.classList.contains('is-closed')) {
                    gsap.to(tableContent, {
                        duration: .5,
                        x: 0,
                        ease: 'power3.easeOut',
                    });
                    gsap.to(tableContentClose, {
                        duration: .5,
                        x: tableContentClose.classList.contains('is-closed') ? tocCloseOffset : null,
                        rotation: tableContentClose.classList.contains('is-closed') ? 0 : null,
                        // x: offset(articleContent).left - tableContentClose.offsetWidth,
                        // rotation: 0,
                        ease: 'power3.easeOut',
                        onComplete: () => {
                            tableContentClose.classList.toggle('is-closed');
                        }
                    });
                    gsap.to(articleContent, {
                        duration: .5,
                        x: tableContentClose.classList.contains('is-closed') ? 0 : null,
                        ease: 'power3.easeOut',
                    });
                }
            }
        } else {
            if (isScrolling === false) {
                if (scrollPosition >= navbar.offsetHeight) {
                    navbar.classList.add('is-scrolled');
                } else {
                    navbar.classList.remove('is-scrolled');
                }
            }
        }
        // tableContentLinks.forEach(link => {
        //     let section = document.querySelector(link.hash);
        //     if (section.offsetTop <= fromTop && section.offsetTop + section.offsetHeight > fromTop) {
        //         link.classList.add('has-text-blue');
        //     } else {
        //         link.classList.remove('has-text-blue');
        //     }
        // });
        // console.log('scrollPosition', scrollPosition, 'Direction', scrollPosition > position ? 'down' : 'up');
        position = scrollPosition;
    }
}, false);


navbarBurger.addEventListener('click', (e) => {
    e.preventDefault();
    navbarBurger.classList.toggle('is-active');
    navbarMenu.classList.toggle('is-active');
    // search.classList.toggle('is-active');
    // search.classList.contains('is-active') ? search.classList.remove('is-active') : search.classList.add('is-active');
    if (search.classList.contains('is-hidden')) {
        body.classList.toggle('is-clipped');
        root.classList.toggle('is-clipped');
    } else {
        search.classList.add('is-hidden');
        // body.classList.toggle('is-clipped');
        // root.classList.toggle('is-clipped');
    }
    //search.classList.remove('is-hidden')
});

let searchBtn = Array.from(document.querySelectorAll('.search-btn'));
let search = document.getElementById('search');
if (searchBtn.length > 0) {
    searchBtn.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            gsap.set(search, { height: wh - navbar.offsetHeight });
            if (ww > 1024) {
                body.classList.toggle('is-clipped');
                root.classList.toggle('is-clipped');
            } else {
                if (!search.classList.contains('is-hidden')) {
                    body.classList.remove('is-clipped');
                    root.classList.remove('is-clipped');
                }
                navbarBurger.classList.remove('is-active');
                navbarMenu.classList.remove('is-active');
            }
            // gsap.to(search, { height: navbar.classList.contains('is-scrolled') ? wh - navbar.offsetHeight : wh - navbar.offsetHeight - largeHeader.offsetHeight });
            btn.classList.toggle('is-active');
            // search.classList.toggle('is-active');
            search.classList.contains('is-hidden') ? search.classList.remove('is-hidden') : search.classList.add('is-hidden');
        });
    });
}
// searchBtn.onclick = function(e) {
//     e.preventDefault();
//     gsap.to(search, { height: wh - navbar.offsetHeight });
//     // gsap.to(search, { height: navbar.classList.contains('is-scrolled') ? wh - navbar.offsetHeight : wh - navbar.offsetHeight - largeHeader.offsetHeight });
//     searchBtn.classList.toggle('is-active');
//     search.classList.toggle('is-active');
//     search.classList.contains('is-hidden') ? search.classList.remove('is-hidden') : search.classList.add('is-hidden');
//     root.classList.toggle('is-clipped');
//     // if (ww <= 768) {
//     //     root.classList.contains('is-clipped') ? root.classList.remove('is-clipped') : root.classList.toggle('is-clipped'); //root.classList.add('is-clipped');
//     //     body.classList.contains('is-clipped') ? body.classList.remove('is-clipped') : body.classList.toggle('is-clipped'); //body.classList.add('is-clipped')
//     // }
// };

if (typeof(tableContentClose) != 'undefined' && tableContentClose != null) {
    // ww < 1024 ? tableContentClose.classList.add('is-closed') : null;
    // ww < 1024 ? gsap.set('#table-of-contents', { x: tocOffset }) : null;
    // ww < 1024 ? gsap.set(tableContentClose, { x: tocCloseOffset, rotation: 180 }) : null;
    tableContentClose.addEventListener('click', (e) => {
        e.preventDefault();
        // if (ww < 1024) {
        //     body.classList.toggle('is-clipped');
        //     root.classList.toggle('is-clipped');
        // }
        gsap.to('#table-of-contents', {
            duration: .5,
            x: tableContentClose.classList.contains('is-closed') ? 0 : tocOffset,
            ease: 'power3.easeOut',
        });
        gsap.to(tableContentClose, {
            duration: .5,
            x: tableContentClose.classList.contains('is-closed') ? tocCloseOffset : 0,
            rotation: tableContentClose.classList.contains('is-closed') ? 0 : 180,
            ease: 'power3.easeOut',
            onComplete: () => {
                tableContentClose.classList.toggle('is-closed');
                // if (navbar.classList.contains('is-scrolled')) {
                //     gsap.to(navbar, {
                //         y: '-100%',
                //         duration: .3,
                //         ease: 'power3.easeOut',
                //     });
                // }
            }
        });
        if (ww >= 1024) {
            gsap.to(articleContent, {
                duration: .5,
                x: tableContentClose.classList.contains('is-closed') ? 0 : '-15%',
                ease: 'power3.easeOut',
            });
        }
    });

    console.log('footerheight', document.querySelector('.footer').offsetHeight);
    gsap.to(tableContentClose, {
        scrollTrigger: {
            // scroller: '.post-content',
            trigger: '.footer',
            // markers: true,
            start: 'top bottom',
            scrub: true,
            end: 'bottom bottom-=' + document.querySelector('.footer').offsetHeight,
            toggleActions: 'play none restart none',
            // toggleClass: 'is-active',
            onEnter: () => {},
            onEnterBack: () => {}
        },
        duration: .5,
        top: -document.querySelector('.footer').offsetHeight,
        ease: 'power3.easeOut',
    });
}

var activeModalGallery = [];
const imageBlocks = Array.from(document.querySelectorAll('.image figure'));
const galleryBlocks = Array.from(document.querySelectorAll('.image-gallery'));
const modalBlocks = [].concat(imageBlocks, galleryBlocks);
if (modalBlocks.length > 0) {
    modalBlocks.forEach(el => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const modalEl = el.nextElementSibling;
            modalEl.classList.toggle('is-active');
            root.classList.toggle('is-clipped');
            body.classList.toggle('modal-active');
            const modalGallery = modalEl.querySelector('.glide');
            if (typeof(modalGallery) != 'undefined' && modalGallery != null) {
                var glide = new Glide(modalGallery, {
                    type: 'carousel',
                    gap: 0,
                    startAt: 0,
                    perView: 1,
                    animationDuration: 250
                });
                glide.mount();
                activeModalGallery.push(glide);
            }
        });
    });
}

const modalCloseBtn = Array.from(document.querySelectorAll('.modal-close'));
if (modalCloseBtn.length > 0) {
    modalCloseBtn.forEach(el => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            if (activeModalGallery.length > 0) {
                activeModalGallery.forEach(glideEl => {
                    if (typeof(glideEl) != 'undefined' && glideEl != null) {
                        glideEl.destroy();
                    }
                });
                activeModalGallery = [];
            }
            const modalEl = el.parentElement;
            modalEl.classList.remove('is-active');
            root.classList.remove('is-clipped');
            body.classList.remove('modal-active');
        });
    });
}

if (scrollToLinks.length > 0) {
    scrollToLinks.forEach(el => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const linkTarget = el.getAttribute('href')
            if (typeof(linkTarget) != 'undefined' && linkTarget != null) {
                console.log(linkTarget);
                isScrolling = true;
                gsap.to(window, {
                    duration: .75,
                    scrollTo: { y: linkTarget, offsetY: navbar.offsetHeight + 20 },
                    onStart: () => {
                        if (typeof(tableContentClose) != 'undefined' && tableContentClose != null) {
                            if (ww < 1024 && !tableContentClose.classList.contains('is-closed')) {
                                gsap.to('#table-of-contents', {
                                    duration: .5,
                                    x: tocOffset,
                                    ease: 'power3.easeOut',
                                });
                                gsap.to(tableContentClose, {
                                    duration: .5,
                                    x: 0,
                                    rotation: 180,
                                    ease: 'power3.easeOut',
                                    onComplete: () => {
                                        tableContentClose.classList.toggle('is-closed');
                                        // if (navbar.classList.contains('is-scrolled')) {
                                        //     gsap.to(navbar, {
                                        //         y: '-100%',
                                        //         duration: .3,
                                        //         ease: 'power3.easeOut',
                                        //     });
                                        // }
                                    }
                                });
                            }
                        }
                    },
                    onComplete: () => {
                        isScrolling = false;
                        console.log('isScrolling', isScrolling);
                        // if (navbar.classList.contains('is-scrolled')) {
                        //     navbar.classList.remove('is-scrolled');
                        //     gsap.to(navbar, {
                        //         y: '-100%',
                        //         duration: .3,
                        //         ease: 'power3.easeOut',
                        //     });
                        // }
                    }
                });
            }
        });
    });
}

if (tableContent) {
    // console.log(tableContent);
    gsap.utils.toArray('.has-toc .table-content-heading').forEach(headingEl => {
        // console.log('headingEl', headingEl);
        gsap.to(headingEl, {
            paused: true,
            scrollTrigger: {
                trigger: headingEl,
                // markers: true,
                start: 'top center',
                end: 'bottom center-=10%', // + animEl.parentNode.parentNode.offsetHeight,top+=250px
                toggleActions: 'play none none none',
                toggleClass: 'is-active',
                onEnter: () => {
                    [].forEach.call(tableContentLinks, function(el) {
                        el.classList.remove('has-text-blue'); //, 'has-text-weight-bold'
                    });
                    var toclink = document.querySelector('a[href="#' + headingEl.id + '"]');
                    toclink.classList.add('has-text-blue'); //, 'has-text-weight-bold'
                },
                onEnterBack: () => {
                    [].forEach.call(tableContentLinks, function(el) {
                        el.classList.remove('has-text-blue'); //, 'has-text-weight-bold'
                    });
                    var toclink = document.querySelector('a[href="#' + headingEl.id + '"]');
                    toclink.classList.add('has-text-blue'); //, 'has-text-weight-bold'
                }
            }
        });
    });
}


// document.addEventListener('mousemove', getMousePosition);

// function getMousePosition(e) {
//     // console.log(e.clientY);
//     if (navbar.classList.contains('is-scrolled') && e.clientY <= navbar.offsetHeight) {
//         gsap.to(navbar, {
//             y: '0%',
//             duration: .5,
//             ease: 'power3.easeOut',
//         });
//         navbar.classList.remove('is-scrolled');
//         if (main.firstElementChild.classList.contains('single-post')) {
//             gsap.to('.project-facts', { y: 0, duration: .3 })
//         }
//     } else {
//         // gsap.to(navbar, {
//         //     y: '-100%',
//         //     duration: .5,
//         //     ease: 'power3.easeOut',
//         //     delay: 1
//         // });
//         // navbar.classList.add('is-scrolled');
//         // if (main.firstElementChild.classList.contains('single-post')) {
//         //     gsap.to('.project-facts', { y: -navbar.offsetHeight, duration: .3, delay: 1 })
//         // }
//     }
// }

function windowResize() {
    ww = window.innerWidth;
    wh = window.innerHeight;
    console.log('RESIZED: ww:', ww, ' | wh:', wh);

    // gsap.to(tableContentClose, {
    //     duration: .5,
    //     x: tableContentClose.classList.contains('is-closed') ? tocCloseOffset : 0,
    //     rotation: tableContentClose.classList.contains('is-closed') ? 0 : 180,
    //     ease: 'power3.easeOut',
    //     onComplete: () => {
    //         tableContentClose.classList.toggle('is-closed');
    //     }
    // });
    tocCloseOffset = body.classList.contains('single-post') ? offset(articleContent).left : null; //- tableContentClose.offsetWidth 
    tocOffset = body.classList.contains('single-post') ? -tableContent.offsetWidth - offset(tableContent).left : null;

    gsap.set(main, { paddingTop: ww > 1280 ? navbarMenu.offsetHeight : navbar.offsetHeight });
    body.classList.contains('single-post') ? gsap.set(tableContent, { paddingTop: navbarMenu.offsetHeight }) : null;
    body.classList.contains('single-post') ? gsap.set(tableContentClose, { x: tocCloseOffset }) : null;
}

window.addEventListener('resize', windowResize);

if (root.classList.contains('no-objectfit') || root.classList.contains('no-object-fit')) {
    let imageContainer = Array.from(document.getElementsByClassName('image'));
    if (imageContainer.length > 0) {
        imageContainer.forEach(el => {
            var imgUrl = el.getElementsByTagName('img')[0].getAttribute('data-src');
            // console.log('img ', el.innerHTML);
            if (imgUrl) {
                el.classList.add('compat-object-fit');
                el.style.backgroundImage = 'url(' + imgUrl + ')';
            }
        });
    }
}